import { useFormikContext } from "formik";
import React from "react";

import { Card } from "react-bootstrap";
import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";

type Props = {};

const ReviewTaxDueOrRefundDetails: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();

  return (
    <>
      <Card bg="secondary" className="refund-card">
        <Card.Body>
          <dl className="eds-list eds-dl eds-inline-between">
            <div className="eds-list--item">
              <dt className="text-white">
                Taxes Due or Refund
                <small>(Total Tax Payable - Total Tax Paid)</small>
              </dt>
              <dd className="text-white">
                {values.TaxPaid.BalTaxPayable < 0 ? (
                  <>
                    None (
                    <PriceDisplay price={values.TaxPaid.BalTaxPayable} /> Refund)
                  </>
                ) : (
                  <>
                    {values.TaxPaid.BalTaxPayable > 0 ? (
                      <PriceDisplay price={values.TaxPaid.BalTaxPayable} />
                    ) : (
                      <PriceDisplay price={0} />
                    )}
                  </>
                )}
              </dd>
            </div>
          </dl>
        </Card.Body>
      </Card>
    </>
  );
};

export default ReviewTaxDueOrRefundDetails;
